<script>
export let status = {}
export let letter = ''

let statusClass = ''
let flipped = false
$: if (status.exact) {
  statusClass = 'bg-green-600 text-white'
} else if (status.found) {
  statusClass = 'bg-yellow-500 text-white'
} else if (status.notFound) {
  statusClass = 'bg-gray-300 text-white'
} else {
  statusClass = 'bg-gray-100'
}

$: {
  if(status.checking) {
    flipped = true
    setTimeout(() => {
      flipped = false
    }, 400);
  }
}

</script>

<div class={`flip-card mx-1 uppercase text-4xl leading-[61px] font-mono ${flipped ? ' flipped' : ''}`}>
  <div class="flip-card-inner border">
    <div class="flip-card-front {flipped ? 'bg-gray-100' : statusClass}">{ flipped ? '' : letter }</div>
    <div class="flip-card-back bg-teal-700"></div>
  </div>
</div>
<div class="hidden bg-gray-100 bg-gray-300 bg-gray-500 bg-green-600 bg-yellow-500 text-white"></div>

<style>

.flip-card {
  background-color: transparent;
  width: 58px;
  height: 58px;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flipped .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front, .flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-back {
  transform: rotateY(180deg);
}
</style>